import { LEGAL, parseLegal } from "@/lib/legal";

export function LegalDocument({ docKey }) {
  const doc = LEGAL[docKey];
  if (!doc) return null;
  const blocks = parseLegal(doc.raw);
  return (
    <div className="space-y-4 text-[15px] leading-relaxed" data-testid={`legal-body-${docKey}`}>
      {blocks.map((b, i) => {
        if (b.type === "eff") return <p key={i} className="text-sm font-semibold text-brand">{b.text}</p>;
        if (b.type === "h") return <h2 key={i} className="pt-4 font-display text-lg font-bold text-navy">{b.text}</h2>;
        if (b.type === "sub") return <h3 key={i} className="pt-2 text-base font-semibold text-navy">{b.text}</h3>;
        if (b.type === "ul") return (
          <ul key={i} className="list-disc space-y-1.5 pl-5 text-subtext">
            {b.items.map((it, j) => <li key={j}>{it}</li>)}
          </ul>
        );
        return <p key={i} className="text-subtext">{b.text}</p>;
      })}
    </div>
  );
}
